export { default as createOnePostMutation } from './create-one-post-mutation';
export { default as findByIdPostQuery } from './find-by-id-post-query';
export { default as findManyPostQuery } from './find-many-post-query';
export { default as findOnePostQuery } from './find-one-post-query';
//export { default as postFragment } from './post-fragment';
export { default as removeByIdPostMutation } from './remove-by-id-post-mutation';
export { default as updateByIdPostMutation } from './update-by-id-post-mutation';
